import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';

export interface Notification {
  id: number;
  matter_id?: number;
  matter_guid?: string;
  matter_name?: string;
  region?: string;
  related_id?: number;
  notification_type: string;
  message: string;
  created_at: string;
  is_read: boolean;
}

export default function useNotifications() {
  const { data, error, mutate } = useSWR<Notification[]>(
    '/notifications',
    async (url) => {
      const response = await backendClient.get(url);
      return response.data;
    },
    {
      refreshInterval: 30000, // Refresh every 30 seconds
      revalidateOnFocus: true,
    }
  );

  const markAsRead = async (notificationId: number) => {
    try {
      await backendClient.patch(`/notifications/${notificationId}/mark-read`);
      mutate();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const unreadCount = data?.filter(notification => !notification.is_read).length || 0;

  return {
    notifications: data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
    markAsRead,
    unreadCount,
  };
}